export default __webpack_public_path__ + "static/media/googleicon.e17d4ebb.svg";